import AbstractObserver from '../../utils/abstract-observer.js';

export class VKAuth extends AbstractObserver {
  constructor() {
    super();

    this._data = null;
    this._userData = null;
    this._isAuth = false;
  }

  set data(data) {
    this._data = data;
  }

  set userData(data) {
    this._userData = data;
  }

  set isAuth(data) {
    this._isAuth = data;
  }

  get data() {
    return this._data;
  }

  get userData() {
    return this._userData;
  }

  get isAuth() {
    return this._isAuth;
  }

  updateData(updateType, update) {
    this._data = update;
    this._notify(updateType, update);
  }

  updateUserData(updateType, update) {
    this._userData = update;
    this._notify(updateType, update);
  }

  updateIsAuth(updateType, update) {
    this._isAuth = update;
    this._notify(updateType, update);
  }

  clickButton(updateType) {
    this._notify(updateType);
  }
}
